import { render } from "./TheConfirmDialogModal.vue?vue&type=template&id=ecd0a544"
import script from "./TheConfirmDialogModal.vue?vue&type=script&lang=js"
export * from "./TheConfirmDialogModal.vue?vue&type=script&lang=js"

import "./TheConfirmDialogModal.vue?vue&type=style&index=0&id=ecd0a544&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__